export default "__VITE_ASSET__IcgJ6fKR__"